/**
 * CORE-1685 — эмодзи комплекта в тексте: токен `:agape_N:`.
 *
 * Сервер хранит и отдаёт токены как есть — в тексте сообщения, в превью
 * обсуждения, в цитате ответа, в комментарии; в push и уведомлениях он их
 * вырезает сам. Здесь разбор для показа картинкой, запасной текст для мест,
 * где картинки нет, и вставка из палитры. Без React и RN — проверяется в jest.
 */
import { BRAND_REACTIONS, emojiOfReaction } from '../constants/brandReactions';

const TOKEN_RE = /:(agape_(?:[1-9]|1[01])):/g;

export type EmojiSegment =
  | { type: 'text'; value: string }
  | { type: 'emoji'; reaction: string };

/** Есть ли в тексте хоть один токен комплекта. */
export function hasEmojiTokens(text: string): boolean {
  TOKEN_RE.lastIndex = 0;
  return TOKEN_RE.test(text);
}

/** Текст → куски: обычный текст и эмодзи комплекта. */
export function parseEmojiTokens(text: string): EmojiSegment[] {
  const out: EmojiSegment[] = [];
  if (!text) return out;
  let last = 0;
  TOKEN_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = TOKEN_RE.exec(text)) !== null) {
    if (m.index > last) out.push({ type: 'text', value: text.slice(last, m.index) });
    out.push({ type: 'emoji', reaction: m[1] });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ type: 'text', value: text.slice(last) });
  return out;
}

/**
 * Токены → запасные символы: для превью в списках, цитат одной строкой и
 * подписей. Сообщение из одних токенов читается как символы, а не как пустота.
 */
export function emojiTokensToPlainText(text: string): string {
  if (!text) return '';
  return text.replace(TOKEN_RE, (_m, type: string) => emojiOfReaction(type) ?? '');
}

/** Токен для слага комплекта — то, что палитра вставляет в черновик. */
export function emojiToken(type: string): string {
  return `:${type}:`;
}

/** Вставка из палитры: в конец черновика, с пробелом перед, если нужен. */
export function insertEmojiToken(text: string, type: string): string {
  if (!BRAND_REACTIONS.some((r) => r.type === type)) return text;
  const token = emojiToken(type);
  if (!text) return token;
  return /\s$/.test(text) || text.endsWith(':') ? `${text}${token}` : `${text} ${token}`;
}
